import { useEffect,useState } from "react"
import { Text,Input,Box,FormControl,Select,Menu,MenuButton,MenuList,InputGroup,InputRightElement,
    MenuItem,Button,useToast,SkeletonCircle,SkeletonText } from "@chakra-ui/react"
import { MdPerson,MdLocalShipping } from "react-icons/md"
import {GiWeight} from 'react-icons/gi'
import { getDokumentTip } from "../../util/apiMigracija"
import OsobaSelect from "../osoba/OsobaSelect"

export const SpecifikacijaOdlazakDetails=({readonly=false, organizatori=[],size='xs',id=0,kamion_br='',migracija_datum=new Date().toISOString().split("T")[0],migracija_ijr=new Date().toISOString().split("T")[0],migrdok_tip_id=-1,dokument_broj='',
    migracija_posjednik_id=-1,jibg='',uktezina=0,onChange,migracija_tip="",
    migracija_posjednik_naziv="",migracija_posjednik_mjesto="",migracija_posjednik_drzava="",migracija_posjednik_sifra="",organizator_id=0})=>{
    const [data,setData]=useState({
        id:id,kamion_br:kamion_br,migracija_datum:migracija_datum,migracija_ijr:migracija_ijr,migrdok_tip_id:migrdok_tip_id,dokument_broj:dokument_broj,
        migracija_posjednik_id:migracija_posjednik_id,jibg:jibg,uktezina:uktezina,migracija_tip:migracija_tip,
        migracija_posjednik_naziv:migracija_posjednik_naziv,migracija_posjednik_mjesto:migracija_posjednik_mjesto,migracija_posjednik_drzava:migracija_posjednik_drzava,
        migracija_posjednik_sifra:migracija_posjednik_sifra,organizator_id:organizator_id
      })
      const [dokumenttipovi,setDokumentTipovi]=useState([])
      const [isloading,setIsLoading]=useState(true)
      const [errmsg,setErrMsg]=useState("")
      const [searchosobe,setSearchOsobe]=useState(false);
      
      const toast=useToast();
      useEffect(() => {
        const getDokumentTipovi=async()=>{
            try {
                const _res=await getDokumentTip();
                if (_res.status===200) {
                    const _r=_res.res.filter((item)=>item.migracija_tip_sifra==='OPROD' || item.migracija_tip_sifra==='OKLA' || item.migracija_tip_sifra==='OIZVZ').sort((a,b)=>{
                        if (a.migrdok_tip_id<b.migrdok_tip_id) {
                            return 1;
                        } else {
                            return -1;
                        }
                    })
                    
                    setDokumentTipovi(_r)
                } else {
                    setErrMsg(_res.message);
                }
            } catch (error) {
                setErrMsg(error.message);
            } finally {
                setIsLoading(false);
            }
        }
       getDokumentTipovi();
      }, [])
      
      

      const showMessage=()=>{
        if (errmsg!=="") {
            toast({
                title:"RGG",
                status:"error",
                description:errmsg,
                isClosable:true,
                duration:2500,
                position:"top-right",
            });
        }
      }
      
      const getSkeleton=()=>{
        if (isloading) {
          return (
            <Box display={'flex'} flexDir={'column'} flex={1}>
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={15} spacing='4' skeletonHeight='4' />
            </Box>
          )
        }
      }
      const handleChangeData=(e)=>{
        const _id=e.target.id;
        const _val=e.target.value;
        const _d={...data};
        if (_id==="datmigr") {
            _d.migracija_datum=_val;
        } else if (_id==="ijr") {
            _d.migracija_ijr=_val;
        } else if (_id==="docbr"){
            if (_val.length<=30) {
                _d.dokument_broj=_val.toUpperCase();
            }
        } else if (_id==="kam"){
            if (_val.length<=20) {
                _d.kamion_br=_val.toUpperCase();
            }
        } else if (_id==="tez"){
            if (_val.length<=11) {
                _d.uktezina=parseFloat(_val);
            }
        } else if (_id==="doctip") {
            _d.migrdok_tip_id=Number(_val);
        } else if (_id==="jibg") {
            if (_val.length<=11) {
                _d.jibg=_val.toUpperCase();
            }
        }  else if (_id==="orgpr") {
            _d.organizator_id=Number(_val);
        }
        onChange(_d);
        setData(_d);
      }

const handleSelectOsoba=(_osoba)=>{
    const _d={...data};
    _d.migracija_posjednik_id=_osoba.id;
    _d.migracija_posjednik_naziv=_osoba.naziv;
    _d.migracija_posjednik_mjesto=_osoba.mjesto;
    _d.migracija_posjednik_drzava=_osoba.drzava;
    _d.migracija_posjednik_sifra=_osoba.sifra;
    setData(_d)
    setSearchOsobe(false);
    onChange(_d);
}

const handleChangeMigracijaTip=(_tip)=>{
    const _ar=dokumenttipovi.filter((item)=>item.migracija_tip_sifra===_tip);
    let _migrtipid=-1
    if (_ar.length>0) {
        _migrtipid=_ar[0].migrdok_tip_id;
    }
    setData({...data,migracija_tip:_tip,migrdok_tip_id:_migrtipid,jibg:"",migracija_posjednik_id:-1,migracija_posjednik_naziv:"",migracija_posjednik_mjesto:"",migracija_posjednik_drzava:"",migracija_posjednik_sifra:""});
    setSearchOsobe(true);
}
const getSearchOsobe=()=>{
    if (searchosobe) {
        let _naslov="Domaći partneri";
        let _subtipid="";
        if (data.migracija_tip==="OPROD") {
            _subtipid="os";
        } else if (data.migracija_tip==="OIZVZ") {
            _subtipid="so";
            _naslov="Strani partneri"
        } else if (data.migracija_tip==="OKLA"){
            _subtipid="kl";
            _naslov="Klaonice"
        }
        if (_subtipid!=="") {
            return (
                <Box display={'flex'} flexDirection={'column'} flex={1}>
                    <OsobaSelect onSelect={handleSelectOsoba} naslov={_naslov} subjekttipid={_subtipid} onClose={()=>setSearchOsobe(false)}/>
                </Box>
            )    
        }    
    }
    
    
}
const buildScreen=()=>{
    if (!isloading && !searchosobe) {
        return (
            <>
                <Box mt={'2rem'} display={'flex'} flexDir={'row'} gap={'2.5rem'}>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Organizator prijevoza</Text>       
                        <Select isDisabled={readonly} id="orgpr" size={size} onChange={handleChangeData} value={data.organizator_id}>
                            {organizatori.map((item,index)=>{
                                return (
                                    <option key={`org${item.organizator_subjekt_id}`} value={item.organizator_subjekt_id}>{item.naziv}</option>
                                )
                            })}
                        </Select>
                    </FormControl>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        
                    </FormControl>
                </Box>
                <Box display={'flex'} flexDir={'row'} gap={'2.5rem'}>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Datum</Text>       
                        <Input isReadOnly={readonly} onChange={handleChangeData} value={data.migracija_datum} id="datmigr" size={size} type="date"></Input>
                    </FormControl>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Isporučeno u jedinstv. registar</Text>       
                        <Input isReadOnly={readonly} onChange={handleChangeData} value={data.migracija_ijr} id="ijr" size={size} type="date"></Input>
                    </FormControl>
                </Box>
                <Box display={'flex'} flexDir={'row'} gap={'2.5rem'}>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'} justifyContent={'start'}>
                        <Text fontSize={size}>Posjednik</Text>
                        <Box display={'flex'} flexDir={'row'}>
                            <InputGroup justifyItems={'center'} size={size}>
                            <InputRightElement pointerEvents={'none'} children={<MdPerson/>}/>
                                <Input size={size} fontWeight={'semibold'} isReadOnly variant={'filled'} value={data.migracija_posjednik_id!==-1?`(${data.migracija_posjednik_sifra}) ${data.migracija_posjednik_naziv}`:''}></Input>
                            </InputGroup>
                            <Menu size={size} zIndex={1}>
                                <MenuButton
                                    as={Button} isDisabled={readonly}
                                    aria-label='Options'
                                    variant={'outline'} size={size} colorScheme="grunt2"
                                >...</MenuButton>
                                <MenuList>
                                    
                                    <MenuItem id="OPROD" onClick={()=>handleChangeMigracijaTip("OPROD")} fontSize={size}>Domaći posjednik</MenuItem>
                                    <MenuItem id="OIZVZ" onClick={()=>handleChangeMigracijaTip("OIZVZ")}  fontSize={size}>Izvoz</MenuItem>
                                    <MenuItem id="OKLA" onClick={()=>handleChangeMigracijaTip("OKLA")} fontSize={size}>Klaonica</MenuItem>
                                </MenuList>
                            </Menu>
                        </Box>
                        
                        <Input size={size} isReadOnly variant={'filled'} value={data.migracija_posjednik_id!==-1?`${data.migracija_posjednik_mjesto} (${data.migracija_posjednik_drzava})`:''}></Input>
                    
                    </FormControl>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'} justifyContent={'start'}>
                        <Text hidden={data.migracija_tip!=='OPROD'} fontSize={size}>JIBG</Text>
                        <Input isReadOnly={readonly} id="jibg" onChange={handleChangeData} value={data.jibg} hidden={data.migracija_tip!=='OPROD'} size={size} variant={'outline'}></Input>
                    </FormControl>
                </Box>
                <Box display={'flex'} flexDir={'row'} gap={'2.5rem'}>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Vrsta dokumenta</Text>       
                        <Select isDisabled={readonly} id="doctip" size={size} onChange={handleChangeData} value={data.migrdok_tip_id}>
                            {dokumenttipovi.filter((item)=>item.migracija_tip_sifra===data.migracija_tip).map((item,index)=>{
                                return (
                                    <option key={`mt${item.migrdok_tip_id}`} value={item.migrdok_tip_id}>{item.dokument_naziv}</option>
                                )
                            })}
                        </Select>
                    </FormControl>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Broj dokumenta</Text>       
                        <InputGroup justifyItems={'center'} size={size}>
                            <InputRightElement pointerEvents={'none'} children={'#'}/>
                                <Input isReadOnly={readonly} onChange={handleChangeData} value={data.dokument_broj} id="docbr" size={size} variant={'outline'}></Input>
                            </InputGroup>
                    </FormControl>
                </Box>
                <Box display={'flex'} flexDir={'row'} gap={'2.5rem'}>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Kamion</Text>       
                        <InputGroup justifyItems={'center'} size={size}>
                            <InputRightElement pointerEvents={'none'} children={<MdLocalShipping />}/>
                            <Input isReadOnly={readonly} onChange={handleChangeData} value={data.kamion_br} id="kam" size={size} variant={'outline'}></Input>
                        </InputGroup>
                    </FormControl>
                    <FormControl display={'flex'} flexDir={'column'} flex={1} gap={'0.2rem'}>
                        <Text fontSize={size}>Ukupna težina</Text>       
                        <InputGroup justifyItems={'center'} size={size}>
                            <InputRightElement pointerEvents={'none'} children={<GiWeight/>}/>
                            <Input isReadOnly={readonly} onChange={handleChangeData} value={data.uktezina} id="tez" type="number" min={"0"} max={"99999999999"} size={size} variant={'outline'}></Input>
                        </InputGroup>
                    </FormControl>
                </Box>
                {showMessage()}
            </>
        )
    }
}



        return (
            <Box display={'flex'} flexDirection={'column'} flex={1} gap={'0.5rem'}>
                {buildScreen()}
                {getSkeleton()}
                {getSearchOsobe()}
            </Box>
        )
}